import React from "react";
import {css} from "@emotion/react";

import {CloseIcon} from "@pg-design/icons-module";

import {ReelDetailsControlButton} from "./ReelDetailsControlButton";

interface IProps {
    onClick?(): void;
}

export const ReelDetailsCloseButton = (props: IProps) => {
    return <ReelDetailsControlButton onClick={props.onClick} icon={CloseIcon} iconSize="1.2" css={buttonStyle} />;
};

const buttonStyle = css`
    flex: 0 0 auto;
`;
import React from "react";
import {css} from "@emotion/react";

import {CloseIcon} from "@pg-design/icons-module";

import {ReelDetailsControlButton} from "./ReelDetailsControlButton";

interface IProps {
    onClick?(): void;
}

export const ReelDetailsCloseButton = (props: IProps) => {
    return <ReelDetailsControlButton onClick={props.onClick} icon={CloseIcon} iconSize="1.2" css={buttonStyle} />;
};

const buttonStyle = css`
    flex: 0 0 auto;
`;
